<div class="chat-threads d-flex flex-column h-100">
  <div class="chat-threads__header border-bottom px-3 py-2 d-flex align-items-center flex-shrink-0">
    <h5 class="m-0">{{ "chat.threadsView.title" | translate }}</h5>
  </div>

  <div class="chat-threads__scroll flex-grow-1 overflow-auto p-3">
    @if (loading) {
      <chat-sidebar-skeleton [rows]="4"></chat-sidebar-skeleton>
    } @else if (loadFailed) {
      <div class="text-center py-4">
        <p class="text-muted mb-2">{{ "chat.threadsView.error" | translate }}</p>
        <button type="button" class="btn btn-sm btn-soft-primary" (click)="reload()">
          <i class="ri-refresh-line me-1"></i>{{ "chat.members.retry" | translate }}
        </button>
      </div>
    } @else if (rows.length === 0) {
      <chat-empty-state
        icon="ri-discuss-line"
        titleKey="chat.threadsView.empty"
        hintKey="chat.threadsView.emptyHint"
      ></chat-empty-state>
    } @else {
      @for (row of rows; track trackRow($index, row)) {
        <!-- One thread: source conversation + root + latest replies. The card
             itself is the click target — it jumps to the root in place. -->
        <div class="chat-threads__card border rounded mb-3">
          <div class="d-flex align-items-center gap-2 px-3 pt-2">
            <i [ngClass]="row.channelIcon" class="text-muted" aria-hidden="true"></i>
            <span class="fw-semibold chat-name flex-grow-1 text-truncate">{{ row.channelName }}</span>
            <button
              type="button"
              class="btn btn-sm btn-light flex-shrink-0"
              (click)="open(row)"
              [matTooltip]="'chat.threadsView.open' | translate"
              [attr.aria-label]="'chat.threadsView.open' | translate"
            >
              <i class="ri-arrow-right-line"></i>
            </button>
          </div>

          <div class="px-3 py-2">
            <ng-container
              [ngTemplateOutlet]="threadMessage"
              [ngTemplateOutletContext]="{ $implicit: row.root }"
            ></ng-container>

            @if (row.replies.length > 0) {
              <div class="chat-threads__replies border-start ps-3 mt-2 d-flex flex-column gap-2">
                @for (reply of row.replies; track $index) {
                  <ng-container
                    [ngTemplateOutlet]="threadMessage"
                    [ngTemplateOutletContext]="{ $implicit: reply }"
                  ></ng-container>
                }
              </div>
            }

            <button type="button" class="btn btn-link btn-sm ps-0 mt-1" (click)="open(row)">
              {{ row.replyCountLabel }} · {{ "chat.threadsView.open" | translate }}
            </button>
          </div>
        </div>
      }

      @if (hasMore) {
        <div class="text-center">
          <button type="button" class="btn btn-sm btn-light" [disabled]="loadingMore" (click)="loadMore()">
            @if (loadingMore) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            {{ "chat.threadsView.loadMore" | translate }}
          </button>
        </div>
      }
    }
  </div>
</div>

<ng-template #threadMessage let-message>
  <div class="d-flex gap-2">
    <span class="chat-avatar-tile flex-shrink-0">
      @if (message.authorImage) {
        <img [src]="message.authorImage" [alt]="message.authorName" />
      } @else {
        {{ message.authorInitial }}
      }
    </span>
    <div class="flex-grow-1 overflow-hidden">
      <div class="d-flex align-items-baseline gap-2">
        <span class="fw-semibold chat-name text-truncate">{{ message.authorName }}</span>
        <small class="text-muted flex-shrink-0">{{ message.timeLabel }}</small>
      </div>
      @if (message.deleted) {
        <p class="m-0 fst-italic text-muted">
          {{ "chat.conversation.deletedMessage" | translate }}
        </p>
      } @else if (message.isMedia) {
        <p class="m-0 text-muted d-flex align-items-center gap-1">
          <i [ngClass]="message.fileIcon" aria-hidden="true"></i>
          <span class="text-truncate">{{ message.fileName || ("chat.threadsView.attachment" | translate) }}</span>
        </p>
      } @else {
        <p
          class="m-0 chat-threads__content"
          [innerHTML]="message.content | chatMarkdown: message.mentionRender"
        ></p>
      }
    </div>
  </div>
</ng-template>
